/**
 * Checks if two arrays are equal in length and content.
 */

export function areArraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }

  return true;
}

/**
 * Checks if a string is null, undefined, or empty.
 */

export function isStringNullOrEmpty(value) {
  return value === null || value === undefined || value === "" || value == "";
}

export function mergeArrays(arr1, arr2) {
  return [...new Set([...arr1, ...arr2])];
}

export function mergeObjectArrays(arr1, arr2, key) {
  const map = new Map();
  [...arr1, ...arr2].forEach((item) => {
    map.set(item[key], item);
  });
  return Array.from(map.values());
}
